import styled, { css } from 'styled-components';

export const TipsBackgroundGradientWrapper = styled.div`
  ${({ displayState }) => css`
    position: relative;
    width: 100%;
    height: ${displayState?.height ?? '100%'};
    background: linear-gradient(180.02deg, #E4F8EE 6.08%, rgba(244, 252, 248, 0) 99.98%);
    border-right: 1px solid #E3E3E3;
    border-bottom: ${p => p.bordered ? '1px solid #E3E3E3' : ''};
  `}
`;
